export default __webpack_public_path__ + "static/media/416.fc59bd6b.jpg";